import React from "react";

const FormTitle = ({title, isCenter = false}) => {
    return (
        <div className={`form-title${isCenter ? ' text-center' : ''}`}><span className="form-title-text">{title}</span></div>
    )
}

export default FormTitle;